let csrfToken = null

function getCsrfTokenFromDom() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta && meta.content) {
    return meta.content
  }
  const input = document.querySelector('[name=csrfmiddlewaretoken]')
  return input ? input.value : null
}

// The CSRF cookie is HttpOnly, so non-React consumers (CKEditor plugins,
// legacy jQuery scripts) can only read the token from the DOM. Mirroring the
// rotated token onto the DOM keeps those consumers in sync with the cookie.
function writeCsrfTokenToDom(token) {
  if (typeof document === 'undefined') {
    return
  }
  let meta = document.querySelector('meta[name="csrf-token"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'csrf-token')
    const mountPoint = document.head || document.body
    if (!mountPoint) {
      return
    }
    mountPoint.appendChild(meta)
  }
  meta.setAttribute('content', token)
  document.querySelectorAll('[name=csrfmiddlewaretoken]').forEach((input) => {
    input.value = token
  })
}

export function setCsrfToken(token) {
  csrfToken = token || null
  if (csrfToken) {
    writeCsrfTokenToDom(csrfToken)
  }
}

export function getCsrfToken() {
  return csrfToken || getCsrfTokenFromDom()
}

const ACCOUNT_STATUS_PATH = '/members-api/account/status'

// True for Django's CSRF rejection: 403 whose `detail` (or raw text body) starts with "CSRF Failed".
export function isCsrfFailure(status, body) {
  if (status !== 403) {
    return false
  }
  const text = typeof body === 'string' ? body : body && body.detail
  return typeof text === 'string' && text.startsWith('CSRF Failed')
}

let refreshInFlight = null

// The backend rotates the token on login/impersonation, so another tab can leave this one stale.
// Single-flight: concurrent callers share one request.
export function refreshCsrfToken() {
  if (!refreshInFlight) {
    refreshInFlight = fetch(`${API_BASE_URL || ''}${ACCOUNT_STATUS_PATH}`, {
      credentials: 'include',
      headers: { 'X-Ironscales-Client-Type': 'react' },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`csrf refresh failed: ${res.status}`)
        }
        return res.json()
      })
      .then((json) => {
        setCsrfToken(json.csrfToken)
        return getCsrfToken()
      })
      .finally(() => {
        refreshInFlight = null
      })
  }
  return refreshInFlight
}
